import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Button from "../Button";
import { FiPlus } from "react-icons/fi";
import DashboardSaleTable from "./dashboardSaleTable";
import DashboardPurchaseTable from "./dashboardPurchaseTable";
import DashboardExpenseTable from "./dashboardExpenseTable";
import Tab from "../Tab";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedAmountType, setSelectedAmountType] = useState("Sale");

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    setSelectedAmountType(
      currentPath.charAt(0).toUpperCase() + currentPath.slice(1)
    );
  }, [location]);

  const handleAmountType = (amountType) => {
    setSelectedAmountType(amountType);
    navigate(`/home/dashboard/${amountType.toLowerCase()}`);
  };

  const tabs = [
    { title: "Sale", key: "Sale" },
    { title: "Purchase", key: "Purchase" },
    { title: "Expense", key: "Expense" },
  ];

  const onClick = () => {
    navigate(`/home/transaction/${selectedAmountType}`);
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-center justify-between mt-8 max-lg:flex-col max-lg:gap-5">
        <Tab
          tabs={tabs}
          selectedAmountType={selectedAmountType}
          handleAmountType={handleAmountType}
        />

        <div className="flex justify-end max-lg:w-full">
          <Button
            className={"bg-green hover:bg-darkgreen text-white"}
            icon={<FiPlus />}
            children={"New Transaction"}
            onClick={onClick}
          />
        </div>
      </div>

      <div>
        <Routes>
          <Route path="sale" element={<DashboardSaleTable />} />
          <Route path="purchase" element={<DashboardPurchaseTable />} />
          <Route path="expense" element={<DashboardExpenseTable />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
